import { all } from 'redux-saga/effects';
import { watchRequests, createRequestInstance } from 'redux-saga-requests';
import { get } from 'lodash';
import axios from 'axios';
import request from 'src/services/request';
import authSaga from '@src/redux/domains/auth/sagas';
import routerSaga from './routerSaga';

const createDriver = axiosInstance => ({
  requestInstance: axiosInstance,
  getAbortSource() {
    return axios.CancelToken.source();
  },
  abortRequest(abortSource) {
    abortSource.cancel();
  },
  sendRequest(requestConfig, abortSource) {
    return axiosInstance({
      cancelToken: abortSource.token,
      ...requestConfig
    });
  },
  getSuccessPayload(response) {
    return response;
  },
  getErrorPayload(error) {
    return error;
  }
});

const successAction = (action, payload) => {
  return {
    payload,
    meta: {
      requestAction: action
    }
  };
};

const errorAction = (action, payload) => {
  const errors = get(payload, 'error') || get(payload, 'messages') || get(payload, 'notice');
  return {
    error: true,
    payload: [].concat(errors),
    meta: {
      requestAction: action
    }
  };
};

export default function* rootSaga() {
  yield createRequestInstance({
    driver: createDriver(request),
    successAction,
    errorAction
  });
  yield all([watchRequests(), routerSaga(), authSaga()]);
}
